import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/autoplay';
import { primarycolor } from "../Utils/colors";
import { Skeleton } from "@mui/material";
import Singleslider from "./singleslider";



const Homesliders = ({ sliders }) => {

    return (
        <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            slidesPerView={1.2}
            loop={true}
            loopFillGroupWithBlank={true}
            shortSwipes={true}
            centeredSlides={true}
            color={primarycolor}
            autoplay={{ delay: 5000 }}
            pagination={{
                clickable: true,
            }}
            navigation={false}
            style={{
                "--swiper-pagination-color": "#000",
                "--swiper-navigation-color": "#000",
                "--swiper-navigation-size": "20px"
            }}
        >
            {sliders?.length > 0 ? sliders.map((val, key) => {

                return (
                    <SwiperSlide key={key} >
                        <Singleslider slider={val} />
                    </SwiperSlide>
                )
            }) :
                Array.from({ length: 4 }, (_, index) => {
                    return (
                        <SwiperSlide key={index} >
                            <Skeleton variant="rectangular" sx={{ height: 200, width: 300, borderRadius: 2 }} />
                        </SwiperSlide>
                    )
                })
            }
        </Swiper>
    )
}

export default Homesliders